export class AdhocReportWrapper {
  reportName?: string;
  parameters?: Array<string> = [];
  fileName?:string;
  exportFormat?:string = 'PDF';
}
